import React from 'react';
export function Footer() {
  return <footer className="w-full border-t border-white/10 bg-[#0a0a0a] px-5 py-12 text-center sm:px-8" data-id="element-117" data-mp="32wd2qgad7ltj">
      <p className="text-lg font-extrabold tracking-wide text-[#7c3aed] sm:text-xl" data-id="element-118" data-mp="3ggk6ap6ov1ww">
        🏐 NETBALL READY 360™
      </p>
      <p className="mt-4 text-sm font-bold text-white" data-id="element-119" data-mp="32m1et8sa9itd">
        The #1 system for netball coaches worldwide.
      </p>
      <p className="mt-3 text-xs italic text-neutral-400" data-id="element-120" data-mp="3ufa7afwmplqj">
        Because coaching shouldn't cost you every evening of the week.
      </p>

      <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-neutral-300" data-id="element-121" data-mp="387czflhuzc3">
        <li data-id="element-122" data-mp="3lggez1qbzhis">
          <a href="mailto:support.netballready360@gmail.com" className="hover:text-white" data-id="element-123" data-mp="3qdf4t82yp2b6">
            📧 support.netballready360@gmail.com
          </a>
        </li>
        <li aria-hidden="true" className="text-neutral-600" data-id="element-124" data-mp="2eya1c1v0azqi">
          ·
        </li>
        <li data-id="element-125" data-mp="2evx98vvjb8zq">📲 @netballready360</li>
        <li aria-hidden="true" className="text-neutral-600" data-id="element-126" data-mp="3l90ozzfy550u">
          ·
        </li>
        <li data-id="element-127" data-mp="3gapd7j63ckfz">🌐 www.netballready360.com</li>
      </ul>
    </footer>;
}